import "@hotwired/turbo-rails"
import "./controllers"
import { installConfirmDialog } from "./lib/confirm_dialog"

installConfirmDialog()
